import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import QuoteForm from '../../../components/feature/QuoteForm';

export default function ShingleRoofsPage() {
  useEffect(() => {
    document.title = 'Roof Replacement Near Me | Shingle Roof Installation | Roof Installation Near Me | NWA';
    
    // Set meta tags
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional roof replacement near me in Northwest Arkansas. Expert shingle roof installation, new roof installation, and roof replacement cost estimates. Lifetime warranties. Serving Fayetteville, Rogers, Bentonville. Free roof installation near me quotes.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'roof replacement, roof replacement near me, shingle roof installation, new roof installation, roof installation near me, roof replacement cost, complete roof replacement');
    }
  }, []);

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-slate-900 via-orange-900 to-slate-800 text-white pt-32 pb-20">
        <div className="absolute inset-0 bg-black/30"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Expert Roof Replacement Near Me in Northwest Arkansas
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-orange-100">
              Complete <strong>Roof Replacement</strong> | Premium <strong>Shingle Roof Installation</strong> | <strong>New Roof Installation</strong> | Lifetime Warranties | Professional <strong>Roof Installation Near Me</strong>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="tel:4795551234" className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all transform hover:scale-105 shadow-lg whitespace-nowrap">
                <i className="ri-phone-fill mr-2"></i>
                Call: (479) 555-1234
              </a>
              <a href="#quote-form" className="bg-white hover:bg-gray-100 text-orange-900 px-8 py-4 rounded-lg font-semibold text-lg transition-all transform hover:scale-105 shadow-lg whitespace-nowrap">
                Get Free Estimate
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Introduction */}
            <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                  Complete Roof Replacement Near Me in Fayetteville, Bentonville & Beyond
                </h2>
                <p className="text-lg text-gray-700 mb-4">
                  When searching for <strong>roof replacement near me</strong> in Northwest Arkansas, homeowners need reliable connections to qualified professionals. We help you find expert <strong>shingle roof installation</strong> contractors with extensive experience in complete <strong>roof replacement</strong> throughout Fayetteville, Springdale, Rogers, Bentonville, and surrounding communities. Get competitive <strong>roof replacement cost</strong> estimates and premium <strong>new roof installation</strong> services with lifetime warranties.
                </p>
                <p className="text-lg text-gray-700 mb-4">
                  Our comprehensive <strong>roof replacement</strong> process includes complete tear-off of old materials, thorough deck inspection and repair, premium underlayment installation, and expert <strong>shingle roof installation</strong> of your new roofing system. Whether you're dealing with an aging roof, extensive storm damage, or simply want to upgrade your home's appearance and protection, contractors provide exceptional <strong>roof installation near me</strong> craftsmanship backed by industry-leading warranties.
                </p>
                <p className="text-lg text-gray-700 mb-6">
                  When you need <strong>new roof installation</strong>, choosing the right contractor makes all the difference. Contractors in our network are certified installers delivering exceptional craftsmanship on every <strong>roof replacement</strong> project. They understand <strong>roof replacement cost</strong> concerns and provide transparent pricing with detailed estimates for all <strong>roof installation near me</strong> services.
                </p>
                <div className="grid grid-cols-2 gap-4">
                  <div className="flex items-center text-green-600">
                    <i className="ri-checkbox-circle-fill text-2xl mr-2"></i>
                    <span className="font-semibold">Lifetime Warranties</span>
                  </div>
                  <div className="flex items-center text-green-600">
                    <i className="ri-checkbox-circle-fill text-2xl mr-2"></i>
                    <span className="font-semibold">Premium Materials</span>
                  </div>
                  <div className="flex items-center text-green-600">
                    <i className="ri-checkbox-circle-fill text-2xl mr-2"></i>
                    <span className="font-semibold">Expert Installation</span>
                  </div>
                  <div className="flex items-center text-green-600">
                    <i className="ri-checkbox-circle-fill text-2xl mr-2"></i>
                    <span className="font-semibold">Free Estimates</span>
                  </div>
                </div>
              </div>
              <div className="relative">
                <img 
                  src="https://public.readdy.ai/ai/img_res/97b1c1d6a672badfe4c4b1b6ee9d010c.jpg"
                  alt="Professional roof replacement near me shingle roof installation new roof installation Fayetteville AR"
                  className="rounded-lg shadow-2xl w-full h-auto object-cover"
                />
              </div>
            </div>

            {/* Signs You Need Replacement */}
            <div className="bg-gradient-to-br from-orange-50 to-slate-50 rounded-2xl p-8 md:p-12 mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
                Signs You Need Roof Replacement Near Me
              </h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <i className="ri-time-line text-4xl text-orange-600 mb-4"></i>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Age of Roof</h3>
                  <p className="text-gray-700">
                    Most asphalt shingle roofs last 20-30 years. If your roof is approaching or past this age, <strong>roof replacement</strong> is more cost-effective than ongoing repairs. <strong>New roof installation</strong> provides decades of protection.
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <i className="ri-contrast-drop-2-line text-4xl text-orange-600 mb-4"></i>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Widespread Damage</h3>
                  <p className="text-gray-700">
                    When storm damage, missing shingles, or deterioration affects large areas of your roof, complete <strong>roof replacement near me</strong> is often the best solution. <strong>Shingle roof installation</strong> restores full protection.
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <i className="ri-drop-line text-4xl text-orange-600 mb-4"></i>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Multiple Leaks</h3>
                  <p className="text-gray-700">
                    Multiple leak points or recurring leaks indicate systemic roof failure requiring complete <strong>roof replacement</strong> rather than patch repairs. Professional <strong>roof installation near me</strong> solves the problem permanently.
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <i className="ri-arrow-down-line text-4xl text-orange-600 mb-4"></i>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Sagging Roof Deck</h3>
                  <p className="text-gray-700">
                    Visible sagging indicates structural issues requiring immediate attention, deck repair, and complete <strong>roof replacement near me</strong>. <strong>New roof installation</strong> includes deck repairs for structural integrity.
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <i className="ri-contrast-2-line text-4xl text-orange-600 mb-4"></i>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Granule Loss</h3>
                  <p className="text-gray-700">
                    Excessive granules in gutters and bare spots on shingles indicate advanced wear and reduced protection from the elements. <strong>Shingle roof installation</strong> with premium materials restores protection.
                  </p>
                </div>

                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <i className="ri-home-2-line text-4xl text-orange-600 mb-4"></i>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">Interior Damage</h3>
                  <p className="text-gray-700">
                    Water stains on ceilings, mold growth, or visible daylight through the roof deck all signal the need for <strong>roof replacement</strong>. Professional <strong>roof installation near me</strong> prevents further interior damage.
                  </p>
                </div>
              </div>
            </div>

            {/* Replacement Process */}
            <div className="mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center">
                Our Roof Replacement Process
              </h2>
              <p className="text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                We follow a comprehensive process to ensure your new roof is installed correctly and will protect your home for decades.
              </p>
              <div className="space-y-8">
                <div className="flex gap-6 items-start">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    1
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Free Inspection & Estimate</h3>
                    <p className="text-lg text-gray-700">
                      We conduct a thorough roof inspection, take measurements, assess your home's specific needs, and provide a detailed written estimate with material options, pricing, and timeline. We explain all aspects of the replacement process and answer your questions.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6 items-start">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    2
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Material Selection</h3>
                    <p className="text-lg text-gray-700">
                      Choose from premium roofing materials including architectural shingles, designer shingles, impact-resistant options, and various colors. We help you select materials that match your home's style, meet your budget, and provide optimal performance for Northwest Arkansas weather.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6 items-start">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    3
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Complete Tear-Off</h3>
                    <p className="text-lg text-gray-700">
                      Our crew removes all existing roofing materials down to the deck, including old shingles, underlayment, and damaged flashing. We use tarps and magnetic tools to protect your property and ensure thorough cleanup. This allows us to inspect the deck for any damage requiring repair.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6 items-start">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    4
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Deck Inspection & Repair</h3>
                    <p className="text-lg text-gray-700">
                      With the old roofing removed, we thoroughly inspect the roof deck for rot, damage, or structural issues. We replace any damaged decking to ensure a solid foundation for your new roof. This critical step prevents future problems and ensures proper installation.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6 items-start">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    5
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Underlayment & Protection</h3>
                    <p className="text-lg text-gray-700">
                      We install premium synthetic underlayment for superior water protection, ice and water shield in vulnerable areas like valleys and eaves, and drip edge for proper water management. These protective layers are essential for long-term roof performance.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6 items-start">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    6
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Shingle Installation</h3>
                    <p className="text-lg text-gray-700">
                      Our certified installers install your new shingles according to manufacturer specifications, ensuring proper alignment, nailing patterns, and sealing. We pay special attention to valleys, ridges, and penetrations for optimal water shedding and wind resistance.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6 items-start">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    7
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Ventilation & Finishing</h3>
                    <p className="text-lg text-gray-700">
                      We install or upgrade roof ventilation to ensure proper attic airflow, which extends roof life and improves energy efficiency. We install new flashing around chimneys, vents, and skylights, and complete all ridge caps and finishing details.
                    </p>
                  </div>
                </div>

                <div className="flex gap-6 items-start">
                  <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold flex-shrink-0">
                    8
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">Cleanup & Final Inspection</h3>
                    <p className="text-lg text-gray-700">
                      We conduct thorough cleanup using magnetic tools to collect nails, remove all debris, and leave your property cleaner than we found it. Our final inspection ensures quality workmanship, and we register your warranty for complete peace of mind.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Benefits Section */}
            <div className="bg-gradient-to-br from-slate-900 to-orange-900 text-white rounded-2xl p-8 md:p-12 mb-16">
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center">
                Benefits of Professional Roof Replacement Near Me
              </h2>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="flex items-start">
                  <i className="ri-shield-check-fill text-4xl text-green-400 mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Enhanced Protection</h3>
                    <p className="text-orange-100">
                      <strong>New roof installation</strong> provides superior protection against Northwest Arkansas weather including hail, wind, rain, and temperature extremes. Premium <strong>shingle roof installation</strong> ensures decades of reliable performance.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-home-heart-fill text-4xl text-green-400 mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Increased Home Value</h3>
                    <p className="text-orange-100">
                      <strong>Roof replacement</strong> offers excellent ROI, significantly boosting curb appeal and home value for resale or refinancing. Quality <strong>roof installation near me</strong> is one of the best home improvement investments.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-money-dollar-circle-fill text-4xl text-green-400 mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Lower Energy Costs</h3>
                    <p className="text-orange-100">
                      Modern roofing materials and proper ventilation improve energy efficiency, reducing heating and cooling costs year-round. <strong>New roof installation</strong> includes ventilation upgrades for maximum efficiency.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-tools-fill text-4xl text-green-400 mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Reduced Maintenance</h3>
                    <p className="text-orange-100">
                      New roofs require minimal maintenance and eliminate the need for frequent repairs, saving time and money. Professional <strong>shingle roof installation</strong> ensures worry-free performance for decades.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-file-shield-2-fill text-4xl text-green-400 mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Warranty Protection</h3>
                    <p className="text-orange-100">
                      Comprehensive manufacturer and workmanship warranties provide decades of protection and peace of mind. <strong>Roof replacement near me</strong> includes lifetime warranty options on premium materials.
                    </p>
                  </div>
                </div>

                <div className="flex items-start">
                  <i className="ri-eye-fill text-4xl text-green-400 mr-4 mt-1 flex-shrink-0"></i>
                  <div>
                    <h3 className="text-xl font-bold mb-2">Improved Aesthetics</h3>
                    <p className="text-orange-100">
                      Choose from modern colors and styles that transform your home's appearance and complement your architectural design. <strong>Roof installation near me</strong> enhances curb appeal dramatically.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* FAQ Section */}
            <div className="mb-16">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
                Roof Replacement Near Me FAQs
              </h2>
              <div className="space-y-4 max-w-4xl mx-auto">
                <details className="bg-white rounded-lg shadow-md p-6 group">
                  <summary className="font-bold text-lg text-gray-900 cursor-pointer list-none flex items-center justify-between">
                    How much does roof replacement cost in Northwest Arkansas?
                    <i className="ri-arrow-down-s-line text-2xl text-orange-600 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-gray-700 mt-4 leading-relaxed">
                    <strong>Roof replacement cost</strong> varies based on roof size, pitch, complexity, material choice, and additional features like ventilation upgrades. Most residential <strong>roof replacement near me</strong> projects in Fayetteville, Bentonville, and Rogers range from moderate to premium pricing depending on materials selected. Contractors provide detailed free estimates with transparent pricing including all materials, labor, disposal, and warranty coverage. Many homeowners find that insurance covers <strong>roof replacement cost</strong> when damage is storm-related, making <strong>new roof installation</strong> more affordable than expected.
                  </p>
                </details>

                <details className="bg-white rounded-lg shadow-md p-6 group">
                  <summary className="font-bold text-lg text-gray-900 cursor-pointer list-none flex items-center justify-between">
                    How long does roof replacement take?
                    <i className="ri-arrow-down-s-line text-2xl text-orange-600 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-gray-700 mt-4 leading-relaxed">
                    Most residential <strong>roof replacement</strong> projects in Northwest Arkansas take 2-5 days depending on roof size, complexity, and weather conditions. Simple ranch-style homes may be completed in 1-2 days, while larger or more complex roofs require additional time. Contractors work efficiently while maintaining quality standards for <strong>shingle roof installation</strong>. Weather delays are possible, but they protect your home with tarps if work must pause. They provide a detailed timeline during the estimate process and keep you informed of progress throughout your <strong>roof installation near me</strong> project.
                  </p>
                </details>

                <details className="bg-white rounded-lg shadow-md p-6 group">
                  <summary className="font-bold text-lg text-gray-900 cursor-pointer list-none flex items-center justify-between">
                    Should I repair or replace my roof?
                    <i className="ri-arrow-down-s-line text-2xl text-orange-600 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-gray-700 mt-4 leading-relaxed">
                    This depends on your roof's age, extent of damage, and overall condition. Generally, if your roof is over 20 years old, has widespread damage, or requires frequent repairs, <strong>roof replacement near me</strong> is more cost-effective long-term. For newer roofs with isolated damage, repairs may be sufficient. Contractors provide honest assessments during free inspections, explaining whether repair or <strong>roof replacement</strong> makes the most sense for your situation. They never recommend unnecessary <strong>new roof installation</strong> and always present all viable options with pros and cons of each approach.
                  </p>
                </details>

                <details className="bg-white rounded-lg shadow-md p-6 group">
                  <summary className="font-bold text-lg text-gray-900 cursor-pointer list-none flex items-center justify-between">
                    What's included in your roof replacement service?
                    <i className="ri-arrow-down-s-line text-2xl text-orange-600 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-gray-700 mt-4 leading-relaxed">
                    Complete <strong>roof replacement</strong> includes: removal and disposal of old roofing materials, deck inspection and repair as needed, premium synthetic underlayment, ice and water shield in critical areas, drip edge installation, <strong>shingle roof installation</strong> to manufacturer specifications, new flashing around all penetrations, ridge cap installation, ventilation installation or upgrade, complete cleanup with magnetic nail collection, final quality inspection, and warranty registration. Contractors handle all aspects of <strong>roof installation near me</strong> projects from start to finish, ensuring a hassle-free experience.
                  </p>
                </details>

                <details className="bg-white rounded-lg shadow-md p-6 group">
                  <summary className="font-bold text-lg text-gray-900 cursor-pointer list-none flex items-center justify-between">
                    Can I stay in my home during roof replacement?
                    <i className="ri-arrow-down-s-line text-2xl text-orange-600 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-gray-700 mt-4 leading-relaxed">
                    Yes, most homeowners stay in their homes during roof replacement. The work is done from the exterior, though you'll hear noise during tear-off and installation. We recommend securing valuables that might be affected by vibrations, and some homeowners prefer to be away during the noisiest phases. We protect your landscaping, vehicles, and property with tarps and barriers. Your home remains secure and weather-protected throughout the process. We communicate our schedule so you know what to expect each day.
                  </p>
                </details>

                <details className="bg-white rounded-lg shadow-md p-6 group">
                  <summary className="font-bold text-lg text-gray-900 cursor-pointer list-none flex items-center justify-between">
                    What warranties come with roof replacement?
                    <i className="ri-arrow-down-s-line text-2xl text-orange-600 group-open:rotate-180 transition-transform"></i>
                  </summary>
                  <p className="text-gray-700 mt-4 leading-relaxed">
                    Our roof replacements include comprehensive warranty protection: manufacturer material warranties ranging from 30 years to lifetime depending on shingle selection, our workmanship warranty covering installation quality, and optional extended warranties for additional coverage. We register all warranties on your behalf and provide complete documentation. Premium architectural and designer shingles often include lifetime limited warranties with excellent wind resistance ratings. We explain all warranty terms during the estimate process so you understand your coverage.
                  </p>
                </details>
              </div>
            </div>

            {/* Service Areas */}
            <div className="bg-blue-50 rounded-2xl p-8 md:p-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
                Roof Replacement Service Areas
              </h2>
              <p className="text-lg text-gray-700 text-center mb-8 max-w-3xl mx-auto">
                NWA Roofing provides expert roof replacement services throughout Northwest Arkansas.
              </p>
              <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
                <div className="bg-white rounded-lg p-6 text-center shadow-md">
                  <i className="ri-map-pin-fill text-4xl text-blue-600 mb-3"></i>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">Fayetteville</h3>
                  <p className="text-gray-600">Complete roof replacement & installation services</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-md">
                  <i className="ri-map-pin-fill text-4xl text-blue-600 mb-3"></i>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">Bentonville</h3>
                  <p className="text-gray-600">New roof installation with premium materials</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-md">
                  <i className="ri-map-pin-fill text-4xl text-blue-600 mb-3"></i>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">Rogers</h3>
                  <p className="text-gray-600">Expert roof replacement & warranty protection</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-md">
                  <i className="ri-map-pin-fill text-4xl text-blue-600 mb-3"></i>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">Springdale</h3>
                  <p className="text-gray-600">Professional roofing installation services</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-md">
                  <i className="ri-map-pin-fill text-4xl text-blue-600 mb-3"></i>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">Bella Vista</h3>
                  <p className="text-gray-600">Complete tear-off & replacement services</p>
                </div>
                <div className="bg-white rounded-lg p-6 text-center shadow-md">
                  <i className="ri-map-pin-fill text-4xl text-blue-600 mb-3"></i>
                  <h3 className="font-bold text-xl text-gray-900 mb-2">All NWA</h3>
                  <p className="text-gray-600">Serving all Northwest Arkansas communities</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quote Form Section */}
      <section id="quote-form" className="py-16 bg-gradient-to-br from-slate-900 to-blue-900">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                Get Your Free Roof Replacement Estimate
              </h2>
              <p className="text-xl text-blue-100">
                Ready for a beautiful new roof? Contact us today for a free, detailed estimate!
              </p>
            </div>
            <QuoteForm />
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12 text-center">
            Related Roofing Services
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <Link to="/services/roof-inspection" className="group bg-gradient-to-br from-blue-50 to-slate-50 rounded-xl p-6 hover:shadow-xl transition-all transform hover:-translate-y-1">
              <i className="ri-search-eye-line text-4xl text-blue-600 mb-4"></i>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                Free Roof Inspections
              </h3>
              <p className="text-gray-600 mb-4">
                Professional inspections to assess whether repair or replacement is needed.
              </p>
              <span className="text-blue-600 font-semibold group-hover:underline">
                Learn More <i className="ri-arrow-right-line"></i>
              </span>
            </Link>

            <Link to="/services/asphalt-shingle-roof" className="group bg-gradient-to-br from-blue-50 to-slate-50 rounded-xl p-6 hover:shadow-xl transition-all transform hover:-translate-y-1">
              <i className="ri-stack-fill text-4xl text-blue-600 mb-4"></i>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                Asphalt Shingle Roofing
              </h3>
              <p className="text-gray-600 mb-4">
                Learn about premium asphalt shingle options for your roof replacement.
              </p>
              <span className="text-blue-600 font-semibold group-hover:underline">
                Learn More <i className="ri-arrow-right-line"></i>
              </span>
            </Link>

            <Link to="/services/insurance-adjuster" className="group bg-gradient-to-br from-blue-50 to-slate-50 rounded-xl p-6 hover:shadow-xl transition-all transform hover:-translate-y-1">
              <i className="ri-file-shield-2-line text-4xl text-blue-600 mb-4"></i>
              <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">
                Insurance Claims Help
              </h3>
              <p className="text-gray-600 mb-4">
                Get assistance with insurance claims for storm damage roof replacement.
              </p>
              <span className="text-blue-600 font-semibold group-hover:underline">
                Learn More <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}